<template>
  <img src="https://res.cloudinary.com/sirrus/image/upload/v1606425497/delivery/modas/assets/icone_chrgzf.png" class="centered" />
</template>

<script>
export default {
  name: "CookLogo"
};
</script>

<style scoped>
.centered {
  width: 80%;
  position: fixed;
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/app/components/CookLogo.vue